export const getSessionId = () => {
  const cookie = new URLSearchParams(document.cookie);

  return cookie.get('sessionId');
};
